import React from 'react';
import LetterFormationHeader from 'components/layout/letter-formation-header';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';

const LetterFormationContainer = ({ isLite, children }: any) => {
  const classes = useStyles();
  const { container, header } = classes;

  return isLite ? (
    children
  ) : (
    <Box className={container}>
      <Box className={header}>
        <LetterFormationHeader />
      </Box>
      {children}
    </Box>
  );
};

const useStyles = makeStyles({
  container: {
    width: '90%',
    height: '100vh',
    margin: 'auto',
  },
  header: {},
});

export default LetterFormationContainer;
